import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=045c32e0"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045c32e0')) {
      api.createRecord('045c32e0', component.options)
    } else {
      api.reload('045c32e0', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=045c32e0", function () {
      api.rerender('045c32e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/globals/Logo.vue"
export default component.exports